import { useEffect } from 'react'

import { useDataBoxSelector, useDataBoxStatus } from 'app/common/data-box-store'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  classTypeFilterSelection,
  defaultEducationLevelsDataReceiver,
  educationLevelsFilter,
  educationLevelsFilterSelection,
  orgsFilterSelection,
  orgTypesFilterSelection,
  parallelsFilterSelection,
  schoolYearFilterSelection,
} from 'app/dataProviders/filter-items'
import { OrgType } from 'app/dataTypes/org'

import { DetailedSubsidyClassType } from './types'

type Props = { id: string; pending: boolean }

export const EducationLevelsFilter = ({ id, pending }: Props) => {
  const orgType = useDataBoxSelector(orgTypesFilterSelection, () => orgTypesFilterSelection.data)
  const orgs = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  const years = useDataBoxSelector(schoolYearFilterSelection, () => schoolYearFilterSelection.data)
  const classType = useDataBoxSelector(
    classTypeFilterSelection,
    () => classTypeFilterSelection.data,
  )
  const parallels = useDataBoxSelector(
    parallelsFilterSelection,
    () => parallelsFilterSelection.data,
  )
  const items = useDataBoxSelector(educationLevelsFilter, () => educationLevelsFilter.data)
  const loading = useDataBoxStatus(educationLevelsFilter, () => educationLevelsFilter.pending)
  const enabled =
    orgType[0] === OrgType.School &&
    orgs.length === 1 &&
    years.length === 1 &&
    classType[0] === DetailedSubsidyClassType.Common
  const visible = enabled && (loading || items.length > 0)

  useEffect(() => {
    educationLevelsFilterSelection.resetToDefault()
    if (!enabled) {
      educationLevelsFilter.resetToDefault()
      return
    }

    educationLevelsFilter.setStatusPending()
    defaultEducationLevelsDataReceiver(orgs[0], years[0], parallels).then((items) => {
      educationLevelsFilter.updateData(() => items)
      educationLevelsFilter.setStatusReady()
    })
  }, [orgs, years, parallels, enabled])

  if (!visible) return null
  return (
    <PlainItemsSelectorBox
      id={id}
      label="Уровень образования"
      header="Выбор уровня образования"
      dataBoxData={educationLevelsFilter}
      dataBoxSelection={educationLevelsFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      multiple
      disabled={pending}
    />
  )
}
